import styled from '@emotion/styled';
import { CourseView } from 'src/containers/academy/course/CourseView';
import { useParams, useLocation } from 'react-router-dom';
import { Dashboard } from 'src/containers/academy/dashboard/Dashboard';
import { StudentProvider, useStudent } from 'src/containers/academy/context/StudentContext';
import academyService from 'src/services/api/academyService';
import { useState } from 'react';
import AcademyLogin from 'src/containers/academy/login/AcademyLogin';
import { screenSizes } from 'src/assets/styles/Literals';
import queryString from 'query-string';
import Swal from 'sweetalert2';

const AcademyContainer = styled.div`
  min-height: 100vh;
  padding: 2rem;
  @media (max-width: ${screenSizes.tablet}) {
    padding: 2rem 0.5rem;
  }
`;

const Academy = () => {
  const { courseId } = useParams();
  const location = useLocation();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [createAccount, setCreateAccount] = useState(false);

  const { setStudentData, student } = useStudent();

  const getStudentProgress = async ({ identification, captcha }) => {
    const queryParams = queryString.parse(location.search);
    const body = { identification, captcha };

    if (queryParams.authCourses) {
      body.authCourses = JSON.parse(queryParams.authCourses);
    }

    academyService
      .getStudentProgress(body)
      .then((response) => {
        const { success, code, message, studentProgress, AcademyCourses } = response.data || {};

        if (success && studentProgress?.id) {
          studentProgress.courseProgress = studentProgress?.AcademyProgresses?.reduce(
            (acc, curr) => ({ ...acc, [curr.course_id]: curr }),
            {}
          );
          setStudentData(studentProgress);
          setCourses(AcademyCourses || []);
          setCreateAccount(false);
          return;
        }

        if (code === 'NO_ACCOUNT') {
          setCreateAccount(true);
          return;
        }

        Swal.fire({
          icon: 'warning',
          title: 'No se pudo iniciar sesión',
          text:
            message ||
            (code === 'NOT_GROUP_LEADER'
              ? 'Acceso exclusivo para líderes de grupo activos'
              : 'Ocurrió un error. Intenta de nuevo.'),
        });
        setCreateAccount(false);
      })
      .catch((err) => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: err.response?.data?.message || 'Error al iniciar sesión. Intenta de nuevo.',
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const course = courses?.find((course) => course?.id === Number(courseId));

  if (!student?.id) {
    return (
      <AcademyLogin
        getStudentProgress={getStudentProgress}
        setLoading={setLoading}
        loading={loading}
        createAccount={createAccount}
      />
    );
  }

  return (
    <AcademyContainer>
      {course?.id ? (
        <CourseView course={course} />
      ) : (
        <Dashboard courses={courses} getStudentProgress={getStudentProgress} />
      )}
    </AcademyContainer>
  );
};

const AcademyComponent = () => (
  <StudentProvider>
    <Academy />
  </StudentProvider>
);

export default AcademyComponent;
